import { createSlice } from '@reduxjs/toolkit';

/**
 * Template selection state (client-side, not server data).
 *
 * Replaces the classic-Redux pair:
 *   - reducers/templateReducer.js
 *   - actions/templateActions.js
 *
 * Keyed by moduleId → templateDetails. selectTemplateDetails sets one entry,
 * resetTemplateDetails clears the whole map (the reducer ignored its moduleId
 * argument; preserved here for backward compatibility with existing call sites).
 *
 * Slice name remains `template` so existing `useSelector(state => state.template)`
 * consumers keep working without changes.
 */
const templateClientSlice = createSlice({
  name: 'template',
  initialState: {},
  reducers: {
    selectTemplateDetails: {
      reducer: (state, action) => {
        const { moduleId, templateDetails } = action.payload;
        state[moduleId] = templateDetails;
      },
      // Preserve the (moduleId, templateDetails) call signature.
      prepare: (moduleId, templateDetails) => ({
        payload: { moduleId, templateDetails },
      }),
    },
    resetTemplateDetails: {
      // Old reducer ignored the moduleId argument and reset the whole map.
      // Preserved verbatim. If a per-module reset is desired, add a new action.
      reducer: () => ({}),
      prepare: (moduleId) => ({
        payload: moduleId,
      }),
    },
  },
});

export const { selectTemplateDetails, resetTemplateDetails } = templateClientSlice.actions;
export default templateClientSlice.reducer;
